<template>
  <div class="base-button">
    <button @click="buttonClicked">{{ title }}</button>
  </div>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  methods: {
    buttonClicked() {
      this.$emit('buttonClicked');
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  
  color: #272630;
  font-size: 16px;
  line-height: 18px;
  appearance: none;
  border: 0;
  border-radius: 25px;
  background-color: #ededec;
  padding: 16px 22px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  position: relative;

  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: all 0.3s ease-in-out;
    border-radius: 25px;
  }

  &:before {
    box-shadow: inset 0 5px 10px 0 rgba(0, 0, 0, 0.03), -20px -20px 20px 0 rgba(255, 255, 255, 0.3),
      -10px -10px 10px 0 rgba(255, 255, 255, 0.3), 10px 10px 10px 0 rgba(39, 38, 48, 0.1),
      20px 20px 20px 0 rgba(39, 38, 48, 0.1);
  }

  &:after {
    box-shadow: inset -5px -5px 15px 0 rgba(255, 255, 255, 0.4),
      inset 5px 5px 15px 0 rgba(0, 0, 0, 0.06);
    opacity: 0;
  }

  &:focus {
    outline: none;
  }

  &:hover {
    background-color: transparent;

    &:before {
      opacity: 0;
    }

    &:after {
      opacity: 1;
    }
  }
}
</style>
